import APi from 'api'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import useQueryParams from 'utils/hooks/useQueryParams'
import { ROUTES } from 'constants/routes'
import { notificationShow } from 'modules/Notifications/actions'

const TargetMailCode = () => {
  const pathGen = useGeneratePathI18n()

  const dispatch = useDispatch()
  const { query: { code } = {} } = useQueryParams()

  useEffect(() => {
    const api = new APi({
      baseURL: '/api/app/v1',
    })

    api
      .get('/networks/targetmail/oauth/user-info', {
        params: { code },
      })
      .then(({ response, error }) => {
        if (error) {
          throw error
        } else {
          if (!global.opener || typeof global.opener.getBack === 'undefined') {
            global.location.assign(
              pathGen(ROUTES.SERVICES_NETWORK_ACCOUNT_REGISTER, {
                networkType: 'targetmail',
              }),
            )
            return
          }

          global.opener.getBack(response.data)

          global.close()
        }
      })
      .catch((error) => {
        dispatch(
          notificationShow({
            type: 'error',
            message: 'common::notifications.unexpected_error',
          }),
        )
        console.logXHR(error)
      })
  }, [])

  return null
}

export default TargetMailCode
